import { render, staticRenderFns } from "./FormAkun.vue?vue&type=template&id=4ada3e70&"
import script from "./FormAkun.vue?vue&type=script&lang=js&"
export * from "./FormAkun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports